// Generated by scripts/stateTaxBrackets/generate.ts from tax-foundation-2026.csv. Edit the CSV and re-run `yarn generate:state-tax-brackets` rather than this file.
// The method and what it leaves out: scripts/stateTaxBrackets/README.md
import type { StateKey, StateTaxSchedule } from './types';

export const STATE_TAX_YEAR = 2026;

export const STATE_TAX_SCHEDULES: Readonly<Record<StateKey, StateTaxSchedule>> = {
  AL: {
    name: 'Alabama',
    standardDeduction: { single: 3000, marriedJointly: 8500 },
    brackets: {
      single: [
        { floor: 0, rate: 0.02 },
        { floor: 500, rate: 0.04 },
        { floor: 3000, rate: 0.05 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0.02 },
        { floor: 1000, rate: 0.04 },
        { floor: 6000, rate: 0.05 },
      ],
    },
  },
  AK: {
    name: 'Alaska',
    standardDeduction: { single: 0, marriedJointly: 0 },
    brackets: { single: [{ floor: 0, rate: 0 }], marriedJointly: [{ floor: 0, rate: 0 }] },
  },
  AZ: {
    name: 'Arizona',
    standardDeduction: { single: 8350, marriedJointly: 16700 },
    brackets: { single: [{ floor: 0, rate: 0.025 }], marriedJointly: [{ floor: 0, rate: 0.025 }] },
  },
  AR: {
    name: 'Arkansas',
    standardDeduction: { single: 2470, marriedJointly: 4940 },
    brackets: {
      single: [
        { floor: 0, rate: 0.02 },
        { floor: 4600, rate: 0.039 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0.02 },
        { floor: 4600, rate: 0.039 },
      ],
    },
  },
  CA: {
    name: 'California',
    standardDeduction: { single: 5540, marriedJointly: 11080 },
    brackets: {
      single: [
        { floor: 0, rate: 0.01 },
        { floor: 11079, rate: 0.02 },
        { floor: 26264, rate: 0.04 },
        { floor: 41452, rate: 0.06 },
        { floor: 57542, rate: 0.08 },
        { floor: 72724, rate: 0.093 },
        { floor: 371479, rate: 0.103 },
        { floor: 445771, rate: 0.113 },
        { floor: 742953, rate: 0.123 },
        { floor: 1000000, rate: 0.133 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0.01 },
        { floor: 22158, rate: 0.02 },
        { floor: 52528, rate: 0.04 },
        { floor: 82904, rate: 0.06 },
        { floor: 115084, rate: 0.08 },
        { floor: 145448, rate: 0.093 },
        { floor: 742958, rate: 0.103 },
        { floor: 891542, rate: 0.113 },
        { floor: 1000000, rate: 0.123 },
        { floor: 1485906, rate: 0.133 },
      ],
    },
  },
  CO: {
    name: 'Colorado',
    standardDeduction: { single: 16100, marriedJointly: 32200 },
    brackets: { single: [{ floor: 0, rate: 0.044 }], marriedJointly: [{ floor: 0, rate: 0.044 }] },
  },
  CT: {
    name: 'Connecticut',
    standardDeduction: { single: 0, marriedJointly: 0 },
    brackets: {
      single: [
        { floor: 0, rate: 0.02 },
        { floor: 10000, rate: 0.045 },
        { floor: 50000, rate: 0.055 },
        { floor: 100000, rate: 0.06 },
        { floor: 200000, rate: 0.065 },
        { floor: 250000, rate: 0.069 },
        { floor: 500000, rate: 0.0699 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0.02 },
        { floor: 20000, rate: 0.045 },
        { floor: 100000, rate: 0.055 },
        { floor: 200000, rate: 0.06 },
        { floor: 400000, rate: 0.065 },
        { floor: 500000, rate: 0.069 },
        { floor: 1000000, rate: 0.0699 },
      ],
    },
  },
  DE: {
    name: 'Delaware',
    standardDeduction: { single: 3250, marriedJointly: 6500 },
    brackets: {
      single: [
        { floor: 0, rate: 0 },
        { floor: 2000, rate: 0.022 },
        { floor: 5000, rate: 0.039 },
        { floor: 10000, rate: 0.048 },
        { floor: 20000, rate: 0.052 },
        { floor: 25000, rate: 0.0555 },
        { floor: 60000, rate: 0.066 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0 },
        { floor: 2000, rate: 0.022 },
        { floor: 5000, rate: 0.039 },
        { floor: 10000, rate: 0.048 },
        { floor: 20000, rate: 0.052 },
        { floor: 25000, rate: 0.0555 },
        { floor: 60000, rate: 0.066 },
      ],
    },
  },
  DC: {
    name: 'District of Columbia',
    standardDeduction: { single: 16100, marriedJointly: 32200 },
    brackets: {
      single: [
        { floor: 0, rate: 0.04 },
        { floor: 10000, rate: 0.06 },
        { floor: 40000, rate: 0.065 },
        { floor: 60000, rate: 0.085 },
        { floor: 250000, rate: 0.0925 },
        { floor: 500000, rate: 0.0975 },
        { floor: 1000000, rate: 0.1075 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0.04 },
        { floor: 10000, rate: 0.06 },
        { floor: 40000, rate: 0.065 },
        { floor: 60000, rate: 0.085 },
        { floor: 250000, rate: 0.0925 },
        { floor: 500000, rate: 0.0975 },
        { floor: 1000000, rate: 0.1075 },
      ],
    },
  },
  FL: {
    name: 'Florida',
    standardDeduction: { single: 0, marriedJointly: 0 },
    brackets: { single: [{ floor: 0, rate: 0 }], marriedJointly: [{ floor: 0, rate: 0 }] },
  },
  GA: {
    name: 'Georgia',
    standardDeduction: { single: 12000, marriedJointly: 24000 },
    brackets: { single: [{ floor: 0, rate: 0.0519 }], marriedJointly: [{ floor: 0, rate: 0.0519 }] },
  },
  HI: {
    name: 'Hawaii',
    standardDeduction: { single: 4400, marriedJointly: 8800 },
    brackets: {
      single: [
        { floor: 0, rate: 0.014 },
        { floor: 9600, rate: 0.032 },
        { floor: 14400, rate: 0.055 },
        { floor: 19200, rate: 0.064 },
        { floor: 24000, rate: 0.068 },
        { floor: 36000, rate: 0.072 },
        { floor: 48000, rate: 0.076 },
        { floor: 125000, rate: 0.079 },
        { floor: 175000, rate: 0.0825 },
        { floor: 225000, rate: 0.09 },
        { floor: 275000, rate: 0.1 },
        { floor: 325000, rate: 0.11 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0.014 },
        { floor: 19200, rate: 0.032 },
        { floor: 28800, rate: 0.055 },
        { floor: 38400, rate: 0.064 },
        { floor: 48000, rate: 0.068 },
        { floor: 72000, rate: 0.072 },
        { floor: 96000, rate: 0.076 },
        { floor: 250000, rate: 0.079 },
        { floor: 350000, rate: 0.0825 },
        { floor: 450000, rate: 0.09 },
        { floor: 550000, rate: 0.1 },
        { floor: 650000, rate: 0.11 },
      ],
    },
  },
  ID: {
    name: 'Idaho',
    standardDeduction: { single: 16100, marriedJointly: 32200 },
    brackets: {
      single: [
        { floor: 0, rate: 0 },
        { floor: 4811, rate: 0.053 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0 },
        { floor: 9622, rate: 0.053 },
      ],
    },
  },
  IL: {
    name: 'Illinois',
    standardDeduction: { single: 0, marriedJointly: 0 },
    brackets: { single: [{ floor: 0, rate: 0.0495 }], marriedJointly: [{ floor: 0, rate: 0.0495 }] },
  },
  IN: {
    name: 'Indiana',
    standardDeduction: { single: 0, marriedJointly: 0 },
    brackets: { single: [{ floor: 0, rate: 0.0295 }], marriedJointly: [{ floor: 0, rate: 0.0295 }] },
  },
  IA: {
    name: 'Iowa',
    standardDeduction: { single: 16100, marriedJointly: 32200 },
    brackets: { single: [{ floor: 0, rate: 0.038 }], marriedJointly: [{ floor: 0, rate: 0.038 }] },
  },
  KS: {
    name: 'Kansas',
    standardDeduction: { single: 3605, marriedJointly: 8240 },
    brackets: {
      single: [
        { floor: 0, rate: 0.052 },
        { floor: 23000, rate: 0.0558 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0.052 },
        { floor: 46000, rate: 0.0558 },
      ],
    },
  },
  KY: {
    name: 'Kentucky',
    standardDeduction: { single: 3360, marriedJointly: 3360 },
    brackets: { single: [{ floor: 0, rate: 0.035 }], marriedJointly: [{ floor: 0, rate: 0.035 }] },
  },
  LA: {
    name: 'Louisiana',
    standardDeduction: { single: 12875, marriedJointly: 25750 },
    brackets: { single: [{ floor: 0, rate: 0.03 }], marriedJointly: [{ floor: 0, rate: 0.03 }] },
  },
  ME: {
    name: 'Maine',
    standardDeduction: { single: 8350, marriedJointly: 16700 },
    brackets: {
      single: [
        { floor: 0, rate: 0.058 },
        { floor: 27399, rate: 0.0675 },
        { floor: 64849, rate: 0.0715 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0.058 },
        { floor: 54849, rate: 0.0675 },
        { floor: 129749, rate: 0.0715 },
      ],
    },
  },
  MD: {
    name: 'Maryland',
    standardDeduction: { single: 3350, marriedJointly: 6700 },
    brackets: {
      single: [
        { floor: 0, rate: 0.02 },
        { floor: 1000, rate: 0.03 },
        { floor: 2000, rate: 0.04 },
        { floor: 3000, rate: 0.0475 },
        { floor: 100000, rate: 0.05 },
        { floor: 125000, rate: 0.0525 },
        { floor: 150000, rate: 0.055 },
        { floor: 250000, rate: 0.0575 },
        { floor: 500000, rate: 0.0625 },
        { floor: 1000000, rate: 0.065 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0.02 },
        { floor: 1000, rate: 0.03 },
        { floor: 2000, rate: 0.04 },
        { floor: 3000, rate: 0.0475 },
        { floor: 150000, rate: 0.05 },
        { floor: 175000, rate: 0.0525 },
        { floor: 225000, rate: 0.055 },
        { floor: 300000, rate: 0.0575 },
        { floor: 600000, rate: 0.0625 },
        { floor: 1200000, rate: 0.065 },
      ],
    },
  },
  MA: {
    name: 'Massachusetts',
    standardDeduction: { single: 0, marriedJointly: 0 },
    brackets: {
      single: [
        { floor: 0, rate: 0.05 },
        { floor: 1083150, rate: 0.09 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0.05 },
        { floor: 1083150, rate: 0.09 },
      ],
    },
  },
  MI: {
    name: 'Michigan',
    standardDeduction: { single: 0, marriedJointly: 0 },
    brackets: { single: [{ floor: 0, rate: 0.0425 }], marriedJointly: [{ floor: 0, rate: 0.0425 }] },
  },
  MN: {
    name: 'Minnesota',
    standardDeduction: { single: 15300, marriedJointly: 30600 },
    brackets: {
      single: [
        { floor: 0, rate: 0.0535 },
        { floor: 33310, rate: 0.068 },
        { floor: 109430, rate: 0.0785 },
        { floor: 203150, rate: 0.0985 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0.0535 },
        { floor: 48700, rate: 0.068 },
        { floor: 193480, rate: 0.0785 },
        { floor: 337930, rate: 0.0985 },
      ],
    },
  },
  MS: {
    name: 'Mississippi',
    standardDeduction: { single: 2300, marriedJointly: 4600 },
    brackets: {
      single: [
        { floor: 0, rate: 0 },
        { floor: 10000, rate: 0.04 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0 },
        { floor: 10000, rate: 0.04 },
      ],
    },
  },
  MO: {
    name: 'Missouri',
    standardDeduction: { single: 16100, marriedJointly: 32200 },
    brackets: {
      single: [
        { floor: 0, rate: 0 },
        { floor: 1348, rate: 0.02 },
        { floor: 2696, rate: 0.025 },
        { floor: 4044, rate: 0.03 },
        { floor: 5392, rate: 0.035 },
        { floor: 6740, rate: 0.04 },
        { floor: 8088, rate: 0.045 },
        { floor: 9436, rate: 0.047 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0 },
        { floor: 1348, rate: 0.02 },
        { floor: 2696, rate: 0.025 },
        { floor: 4044, rate: 0.03 },
        { floor: 5392, rate: 0.035 },
        { floor: 6740, rate: 0.04 },
        { floor: 8088, rate: 0.045 },
        { floor: 9436, rate: 0.047 },
      ],
    },
  },
  MT: {
    name: 'Montana',
    standardDeduction: { single: 16100, marriedJointly: 32200 },
    brackets: {
      single: [
        { floor: 0, rate: 0.047 },
        { floor: 47500, rate: 0.0565 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0.047 },
        { floor: 95000, rate: 0.0565 },
      ],
    },
  },
  NE: {
    name: 'Nebraska',
    standardDeduction: { single: 8850, marriedJointly: 17700 },
    brackets: {
      single: [
        { floor: 0, rate: 0.0246 },
        { floor: 4130, rate: 0.0351 },
        { floor: 24760, rate: 0.0455 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0.0246 },
        { floor: 8250, rate: 0.0351 },
        { floor: 49530, rate: 0.0455 },
      ],
    },
  },
  NV: {
    name: 'Nevada',
    standardDeduction: { single: 0, marriedJointly: 0 },
    brackets: { single: [{ floor: 0, rate: 0 }], marriedJointly: [{ floor: 0, rate: 0 }] },
  },
  NH: {
    name: 'New Hampshire',
    standardDeduction: { single: 0, marriedJointly: 0 },
    brackets: { single: [{ floor: 0, rate: 0 }], marriedJointly: [{ floor: 0, rate: 0 }] },
  },
  NJ: {
    name: 'New Jersey',
    standardDeduction: { single: 0, marriedJointly: 0 },
    brackets: {
      single: [
        { floor: 0, rate: 0.014 },
        { floor: 20000, rate: 0.0175 },
        { floor: 35000, rate: 0.035 },
        { floor: 40000, rate: 0.0553 },
        { floor: 75000, rate: 0.0637 },
        { floor: 500000, rate: 0.0897 },
        { floor: 1000000, rate: 0.1075 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0.014 },
        { floor: 20000, rate: 0.0175 },
        { floor: 50000, rate: 0.0245 },
        { floor: 70000, rate: 0.035 },
        { floor: 80000, rate: 0.0553 },
        { floor: 150000, rate: 0.0637 },
        { floor: 500000, rate: 0.0897 },
        { floor: 1000000, rate: 0.1075 },
      ],
    },
  },
  NM: {
    name: 'New Mexico',
    standardDeduction: { single: 16100, marriedJointly: 32200 },
    brackets: {
      single: [
        { floor: 0, rate: 0.015 },
        { floor: 5500, rate: 0.032 },
        { floor: 16500, rate: 0.043 },
        { floor: 33500, rate: 0.047 },
        { floor: 66500, rate: 0.049 },
        { floor: 210000, rate: 0.059 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0.015 },
        { floor: 8000, rate: 0.032 },
        { floor: 25000, rate: 0.043 },
        { floor: 50000, rate: 0.047 },
        { floor: 100000, rate: 0.049 },
        { floor: 315000, rate: 0.059 },
      ],
    },
  },
  NY: {
    name: 'New York',
    standardDeduction: { single: 8000, marriedJointly: 16050 },
    brackets: {
      single: [
        { floor: 0, rate: 0.039 },
        { floor: 8500, rate: 0.044 },
        { floor: 11700, rate: 0.0515 },
        { floor: 13900, rate: 0.054 },
        { floor: 80650, rate: 0.059 },
        { floor: 215400, rate: 0.0685 },
        { floor: 1077550, rate: 0.0965 },
        { floor: 5000000, rate: 0.103 },
        { floor: 25000000, rate: 0.109 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0.039 },
        { floor: 17150, rate: 0.044 },
        { floor: 23600, rate: 0.0515 },
        { floor: 27900, rate: 0.054 },
        { floor: 161550, rate: 0.059 },
        { floor: 323200, rate: 0.0685 },
        { floor: 2155350, rate: 0.0965 },
        { floor: 5000000, rate: 0.103 },
        { floor: 25000000, rate: 0.109 },
      ],
    },
  },
  NC: {
    name: 'North Carolina',
    standardDeduction: { single: 12750, marriedJointly: 25500 },
    brackets: { single: [{ floor: 0, rate: 0.0399 }], marriedJointly: [{ floor: 0, rate: 0.0399 }] },
  },
  ND: {
    name: 'North Dakota',
    standardDeduction: { single: 16100, marriedJointly: 32200 },
    brackets: {
      single: [
        { floor: 0, rate: 0 },
        { floor: 48475, rate: 0.0195 },
        { floor: 244825, rate: 0.025 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0 },
        { floor: 80975, rate: 0.0195 },
        { floor: 298075, rate: 0.025 },
      ],
    },
  },
  OH: {
    name: 'Ohio',
    standardDeduction: { single: 0, marriedJointly: 0 },
    brackets: {
      single: [
        { floor: 0, rate: 0 },
        { floor: 26050, rate: 0.0275 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0 },
        { floor: 26050, rate: 0.0275 },
      ],
    },
  },
  OK: {
    name: 'Oklahoma',
    standardDeduction: { single: 6350, marriedJointly: 12700 },
    brackets: {
      single: [
        { floor: 0, rate: 0 },
        { floor: 3750, rate: 0.025 },
        { floor: 4900, rate: 0.035 },
        { floor: 7200, rate: 0.045 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0 },
        { floor: 7500, rate: 0.025 },
        { floor: 9800, rate: 0.035 },
        { floor: 14400, rate: 0.045 },
      ],
    },
  },
  OR: {
    name: 'Oregon',
    standardDeduction: { single: 2910, marriedJointly: 5820 },
    brackets: {
      single: [
        { floor: 0, rate: 0.0475 },
        { floor: 4550, rate: 0.0675 },
        { floor: 11400, rate: 0.0875 },
        { floor: 125000, rate: 0.099 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0.0475 },
        { floor: 9100, rate: 0.0675 },
        { floor: 22800, rate: 0.0875 },
        { floor: 250000, rate: 0.099 },
      ],
    },
  },
  PA: {
    name: 'Pennsylvania',
    standardDeduction: { single: 0, marriedJointly: 0 },
    brackets: { single: [{ floor: 0, rate: 0.0307 }], marriedJointly: [{ floor: 0, rate: 0.0307 }] },
  },
  RI: {
    name: 'Rhode Island',
    standardDeduction: { single: 11200, marriedJointly: 22400 },
    brackets: {
      single: [
        { floor: 0, rate: 0.0375 },
        { floor: 82050, rate: 0.0475 },
        { floor: 186450, rate: 0.0599 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0.0375 },
        { floor: 82050, rate: 0.0475 },
        { floor: 186450, rate: 0.0599 },
      ],
    },
  },
  SC: {
    name: 'South Carolina',
    standardDeduction: { single: 8350, marriedJointly: 16700 },
    brackets: {
      single: [
        { floor: 0, rate: 0 },
        { floor: 3640, rate: 0.03 },
        { floor: 18230, rate: 0.06 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0 },
        { floor: 3640, rate: 0.03 },
        { floor: 18230, rate: 0.06 },
      ],
    },
  },
  SD: {
    name: 'South Dakota',
    standardDeduction: { single: 0, marriedJointly: 0 },
    brackets: { single: [{ floor: 0, rate: 0 }], marriedJointly: [{ floor: 0, rate: 0 }] },
  },
  TN: {
    name: 'Tennessee',
    standardDeduction: { single: 0, marriedJointly: 0 },
    brackets: { single: [{ floor: 0, rate: 0 }], marriedJointly: [{ floor: 0, rate: 0 }] },
  },
  TX: {
    name: 'Texas',
    standardDeduction: { single: 0, marriedJointly: 0 },
    brackets: { single: [{ floor: 0, rate: 0 }], marriedJointly: [{ floor: 0, rate: 0 }] },
  },
  UT: {
    name: 'Utah',
    standardDeduction: { single: 0, marriedJointly: 0 },
    brackets: { single: [{ floor: 0, rate: 0.045 }], marriedJointly: [{ floor: 0, rate: 0.045 }] },
  },
  VT: {
    name: 'Vermont',
    standardDeduction: { single: 7650, marriedJointly: 15300 },
    brackets: {
      single: [
        { floor: 0, rate: 0.0335 },
        { floor: 49400, rate: 0.066 },
        { floor: 119700, rate: 0.076 },
        { floor: 249700, rate: 0.0875 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0.0335 },
        { floor: 82500, rate: 0.066 },
        { floor: 199450, rate: 0.076 },
        { floor: 304000, rate: 0.0875 },
      ],
    },
  },
  VA: {
    name: 'Virginia',
    standardDeduction: { single: 8750, marriedJointly: 17500 },
    brackets: {
      single: [
        { floor: 0, rate: 0.02 },
        { floor: 3000, rate: 0.03 },
        { floor: 5000, rate: 0.05 },
        { floor: 17000, rate: 0.0575 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0.02 },
        { floor: 3000, rate: 0.03 },
        { floor: 5000, rate: 0.05 },
        { floor: 17000, rate: 0.0575 },
      ],
    },
  },
  WA: {
    name: 'Washington',
    standardDeduction: { single: 0, marriedJointly: 0 },
    brackets: { single: [{ floor: 0, rate: 0 }], marriedJointly: [{ floor: 0, rate: 0 }] },
  },
  WV: {
    name: 'West Virginia',
    standardDeduction: { single: 0, marriedJointly: 0 },
    brackets: {
      single: [
        { floor: 0, rate: 0.0222 },
        { floor: 10000, rate: 0.0296 },
        { floor: 25000, rate: 0.0333 },
        { floor: 40000, rate: 0.0444 },
        { floor: 60000, rate: 0.0482 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0.0222 },
        { floor: 10000, rate: 0.0296 },
        { floor: 25000, rate: 0.0333 },
        { floor: 40000, rate: 0.0444 },
        { floor: 60000, rate: 0.0482 },
      ],
    },
  },
  WI: {
    name: 'Wisconsin',
    standardDeduction: { single: 13960, marriedJointly: 25840 },
    brackets: {
      single: [
        { floor: 0, rate: 0.035 },
        { floor: 15110, rate: 0.044 },
        { floor: 51950, rate: 0.053 },
        { floor: 332720, rate: 0.0765 },
      ],
      marriedJointly: [
        { floor: 0, rate: 0.035 },
        { floor: 20150, rate: 0.044 },
        { floor: 69260, rate: 0.053 },
        { floor: 443630, rate: 0.0765 },
      ],
    },
  },
  WY: {
    name: 'Wyoming',
    standardDeduction: { single: 0, marriedJointly: 0 },
    brackets: { single: [{ floor: 0, rate: 0 }], marriedJointly: [{ floor: 0, rate: 0 }] },
  },
};
